import {
  Button,
  Container,
  Fab,
  makeStyles,
  Modal,

  Snackbar,
  TextField,
  Tooltip,
} from "@material-ui/core";
// import Files from "react-files";

// import { getAllFamilies, getAllSubFamilies } from "../reduxSaga/actions";
import { Add as AddIcon } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import MuiAlert from "@material-ui/lab/Alert";
import { useDispatch, useSelector } from "react-redux";
// import axios from "axios";
// import Blob from "blob";
// import FormData from "form-data";
import {
  addNewCategory,
} from "../reduxSaga/actions";
// import { Autocomplete } from "@material-ui/lab";

// import {
//   getAllWarehousesManager,

//   addNewRealWarehouse,
// } from "../reduxSaga/actions";

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "fixed",
    bottom: 20,
    right: 20,
  },
  container: {
    borderRadius: 10,
    boxShadow: "0 3px 5px 2px rgba(18,131,255,0.87)",
    width: 500,
    height: 500,
    backgroundColor: "white",
    position: "absolute",
    top: -30,
    bottom: 0,
    left: 0,
    right: 0,
    margin: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "100vw",
      height: "100vh",
      top: 0,
    },
  },

  familyContainer: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
    display: "flex",
    justifyContent: "space-between",
  },
  form: {
    padding: theme.spacing(2),
  },
  item: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
  },

  cancelAndAddButtom: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(5),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  input: {
    "&::placeholder": {
      fontStyle: "italic",
    },
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const AddCategory = ({ setOnAddCategory, familyId, subFamilyId }) => {
  const dispatch = useDispatch();
  // const availableFamilies = useSelector(
  //   (state) => state.staff.availableFamilies
  // );

  const availableSubFamilies = useSelector(
    (state) => state.staff.availableSubFamilies
  );

  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [familyName, setFamilyName] = useState();
  const [subFamilyValue, setSubFamilyValue] = useState(1);
  const [name, setName] = useState();
  const [desc, setDesc] = useState();

  // useEffect(() => {
  //   {
  //     for (let index = 0; index < availableFamilies.length; index++) {
  //       if (availableFamilies[index].id == familyId) {
  //         setFamilyName(availableFamilies[index].name);
  //         break;
  //       }
  //     }
  //   }
  // }, []);

  useEffect(() => {
    for (let index = 0; index < availableSubFamilies.length; index++) {
      if (availableSubFamilies[index].id === subFamilyId) {
        setSubFamilyValue(availableSubFamilies[index].name);
        break;
      }
    }
  }, []);

  /*useEffect(() => {
          {
            if (brandNotification == "success" ) {
              setErrorAlertText("Erreur :le champ du non est vide ! ");
              setOpenErrorAlert(true);
              dispatch(setBrandNotificationState());
              setOnAddCategory(false);
            } 
          }
        }, [brandNotification]);*/

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onChangeName = (event) => {
    setName(event.target.value);
  };

  const onChangeDesc = (event) => {
    setDesc(event.target.value);
  };

  const onCancelButtonHandler = () => {
    setOpen(false);
    setOnAddCategory(false);
  };

  const onAddCategory = () => {
    if (name == null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :le champ du nom est vide ! ");
    } else {
      let categoryModel = {
        idProductSubFamily: subFamilyId,
       
       
       
        categoryName: name,
        description: desc,
        idUserCreation: 0,
      };
      console.log(categoryModel)
      // {
      //   "categoryName": "string",
      //   "description": "string",
      //   "familyName": "fzefzeze",
      //   "idProductFamily":4 ,
      //   "idProductSubFamily": 12,
      //   "idUserCreation": 2,
      //   "subFamilyName": "hahahahah"
      // }

      dispatch(addNewCategory(categoryModel));
      // setOpenErrorAlert(true);
      // setErrorAlertText("success :le champ du non est vide ! ");
      // setTimeout(setOnAddCategory(false), 5000);
      setOnAddCategory(false);
    }
  };

  return (
    <>
      <Tooltip title="Add" aria-label="add" onClick={() => setOpen(true)}>
        <Fab color="primary" className={classes.fab}>
          <AddIcon />
        </Fab>
      </Tooltip>
      <Modal open={open}>
        <Container className={classes.container}>
          <form className={classes.form} autoComplete="off">
            <div className={classes.item}>
              <TextField
                required
                placeholder="Taper le nom  de catégorie "
                id="standard-basic"
                label=" Taper le nom de catégorie "
                variant="outlined"
                size="small"
                style={{ width: "100%" }}
                onChange={onChangeName}
                InputProps={{
                  classes: { input: classes.input },
                }}
              />
            </div>

            <div className={classes.item}>
              <TextField
                disabled
                id="standard-disabled132"
                label="nom de famille correspondant"
                defaultValue={familyName}
                //  placeholder="famille correspondant "

                variant="outlined"
                size="small"
                style={{ width: "100%" }}
              />
            </div>
            <div className={classes.item}>
              <TextField
                disabled
                id="standard-disabled123"
                label="nom de sous famille correspondant"
                defaultValue={subFamilyValue}
                //  placeholder="famille correspondant "

                variant="outlined"
                size="small"
                style={{ width: "100%" }}
              />
            </div>

            <div className={classes.item}>
              <TextField
                id="outlined-multiline-static"
                multiline
                rows={4}
                InputProps={{
                  classes: { input: classes.input },
                }}
                placeholder="Note"
                variant="outlined"
                label="Note"
                size="small"
                style={{ width: "100%" }}
                onChange={onChangeDesc}
              />
            </div>

            <div className={classes.cancelAndAddButtom}>
              <Button
                variant="outlined"
                color="primary"
                style={{ marginRight: 20 }}
                onClick={onAddCategory}
              >
                Create
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={onCancelButtonHandler}
              >
                Cancel
              </Button>
            </div>
          </form>
        </Container>
      </Modal>
      <Snackbar
        open={openAlert}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleClose} severity="success">
          Ajout avec success !
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={4000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AddCategory;
